// TODO Change this for a union type.
enum QuestionKey {
  VEHICLE_TYPE = 'vehicleType',
  LOAN_AMOUNT = 'loanAmount',
  MONTHLY_INCOME = 'monthlyIncome',
  DRIVING_LICENCE = 'drivingLicence',
  MARITAL_STATUS = 'maritalStatus',
  EMPLOYMENT_HISTORY = 'employmentHistory',
  ADDRESS_HISTORY = 'addressHistory',
  PERSONAL_DETAILS = 'personalDetails',
  DATE_OF_BIRTH = 'dateOfBirth',
  CONTACT_INFO = 'contactInfo',
  REQUIRED_DETAILS = 'requiredDetails'
}

export default QuestionKey
